import { useState } from "react";
import api, { fmtIDR } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { fl } from "@/lib/finI18n";
import { Input } from "@/components/ui/input";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { useListKeys } from "@/lib/useListKeys";

export function InvoiceLinkInput({ clientId, value, onChange, onPick, currentId }) {
  const { lang } = useI18n();
  const [all, setAll] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => {
    if (all === null && clientId) api.get(`/invoices?client_id=${clientId}`).then(({ data }) => setAll(data)).catch(() => setAll([]));
  };
  const typed = (value || "").trim().toLowerCase();
  const list = (all || []).filter((d) => (d.status !== "paid" || d.id === currentId)
    && (!typed || `${d.invoice_no} ${d.bill_to?.name || ""}`.toLowerCase().includes(typed))).slice(0, 15);
  const keys = useListKeys(list, { open, setOpen, onPick });

  return (
    <div className="relative">
      <Input value={value} autoComplete="off" placeholder="INV/..." data-testid="txn-sales-invoice"
        onFocus={() => { load(); setOpen(true); }} onChange={(e) => { onChange(e.target.value); setOpen(true); }} {...keys.input}
        onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && (
        <div ref={keys.box} className="absolute z-50 mt-1 w-full min-w-[280px] rounded-md border border-border bg-popover shadow-lg max-h-60 overflow-auto" data-testid="txn-sales-invoice-suggestions">
          {all === null && <div className="px-3 py-2 text-xs text-muted-foreground flex items-center gap-2"><Loader2 className="h-3.5 w-3.5 animate-spin" />{fl("loading", lang)}</div>}
          {list.map((d, i) => (
            <button type="button" key={d.id} {...keys.opt(i)} onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(d); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-accent data-[active]:bg-accent transition-colors" data-testid={`sales-inv-opt-${d.id}`}>
              <span className="flex items-center gap-1.5 font-medium"><FileSpreadsheet className="h-3.5 w-3.5 text-muted-foreground" />{d.invoice_no}</span>
              <span className="block text-[11px] text-muted-foreground">{d.bill_to?.name || "—"} · {fl("balanceDue", lang)} {fmtIDR(d.balance_due)}</span>
            </button>
          ))}
          {all && list.length === 0 && <div className="px-3 py-2 text-xs text-muted-foreground">{fl("noOpenInvoice", lang)}</div>}
        </div>
      )}
    </div>
  );
}
